export const getRivals = (client_wines, rival_wines, wine) => {
  if (!client_wines.length) {
    return [];
  }
  if (!wine) {
    return [];
  }

  return [
    ...new Set(rival_wines.filter((item) => item.client_wine === wine.label))
  ];
};
